import React, { Fragment } from 'react';
import { Field } from 'formik';
import { FovFieldError, FovInput, VerticalSpacer } from 'components';

const NameField = () => {
  return (
    <Fragment>
      Name*
      <VerticalSpacer size={10} />

      <Field type='text' name='contentName'>
        {data => (
          <FovInput
            name={data.field.name}
            value={data.field.value}
            {...data.field}
          />
        )}
      </Field>

      <FovFieldError name='contentName' />
    </Fragment>
  );
};

export default NameField;

